import { MesfModal } from "@dexteel/mesf-core";
import {
	Button,
	Grid,
	Paper,
	TextField,
	Typography,
	makeStyles,
} from "@material-ui/core";
import { DelayByShift } from "../models/DelayByShift";

interface Props {
	delay: DelayByShift | null;
	onHide: () => void;
	open: boolean;
}

const useStyles = makeStyles((theme) => ({
	textField: {
		"& .MuiOutlinedInput-input": {
			height: "60px !important",
		},
	},
}));
export const UpsetConditionModal = ({ delay, onHide, open }: Props) => {
	const classes = useStyles();
	return (
		<>
			<MesfModal
				open={open}
				handleClose={onHide}
				id="upset-condition-modal"
				title="Upset Conditions"
				maxWidth="md"
			>
				<MesfModal.Content>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<TextField
								variant="outlined"
								fullWidth
								size="small"
								label="What"
								value={delay?.WhatDescription}
								disabled
								multiline
								className={classes.textField}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								variant="outlined"
								fullWidth
								size="small"
								multiline
								label="Why"
								value={delay?.WhyDescription}
								disabled
								className={classes.textField}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								variant="outlined"
								fullWidth
								size="small"
								multiline
								label="Solution"
								value={delay?.SolutionDescription}
								disabled
								className={classes.textField}
							/>
						</Grid>
					</Grid>
				</MesfModal.Content>
				<MesfModal.Actions>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid item md={3} xs={3} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="primary"
								onClick={onHide}
								size="small"
							>
								Close
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
